export default __webpack_public_path__ + "static/media/Whiskey.7379a55d.mp3";